/* ============================================================
 * AYU Landing Page – Sacred Modern Design
 * Constants & CDN URLs
 * ============================================================ */

export const IMAGES = {
  heroBg:
    "https://d2xsxph8kpxj0f.cloudfront.net/310519663397508885/Atzyym4VHHtDL2VhJSwxBc/hero-bg-CinzSZGyAWs7qcZdQXoRrs.webp",
  herbs:
    "https://d2xsxph8kpxj0f.cloudfront.net/310519663397508885/Atzyym4VHHtDL2VhJSwxBc/ayurveda-herbs-S8CUivAEp2YSHREASpgK8f.webp",
  mandala:
    "https://d2xsxph8kpxj0f.cloudfront.net/310519663397508885/Atzyym4VHHtDL2VhJSwxBc/mandala-pattern-hPxCQUsQVEerftEioG6LhZ.webp",
  nature:
    "https://d2xsxph8kpxj0f.cloudfront.net/310519663397508885/Atzyym4VHHtDL2VhJSwxBc/meditation-nature-3JfFt8dFGTZQScpRtHSDsK.webp",
  dna: "https://d2xsxph8kpxj0f.cloudfront.net/310519663397508885/Atzyym4VHHtDL2VhJSwxBc/dna-modern-YRofePQpuHXFTjFyizddgF.webp",
  annamOrange:
    "https://d2xsxph8kpxj0f.cloudfront.net/310519663397508885/Atzyym4VHHtDL2VhJSwxBc/yy2eqsqJ55c6_307a7778.jpg",
  annamChris:
    "https://d2xsxph8kpxj0f.cloudfront.net/310519663397508885/Atzyym4VHHtDL2VhJSwxBc/IJiJgVCPG80z_5e68ebc2.jpg",
  annamBlue:
    "https://d2xsxph8kpxj0f.cloudfront.net/310519663397508885/Atzyym4VHHtDL2VhJSwxBc/mvBDspg6VFur_f3b9d4e7.jpeg",
  chris:
    "https://d2xsxph8kpxj0f.cloudfront.net/310519663397508885/Atzyym4VHHtDL2VhJSwxBc/zAs6cOm4LS4V_70c5cbcf.jpg",
  logo: "/branding/ayu-logo.svg",
  phoneMockup:
    "https://d2xsxph8kpxj0f.cloudfront.net/310519663397508885/Atzyym4VHHtDL2VhJSwxBc/ayu-phone-mockup-4JX2t6GvRPZTPk4ycmzwAe.png",
} as const;

export const NAV_ITEMS = [
  { labelKey: "landing.nav.wasIstAyu", href: "#was-ist-ayu" },
  { labelKey: "landing.nav.ayurveda", href: "#ayurveda" },
  { labelKey: "landing.nav.phaenotypen", href: "#phaenotypen" },
  { labelKey: "landing.nav.ayuKompass", href: "#kompass" },
  { labelKey: "landing.nav.tagebuch", href: "#tagebuch" },
  { labelKey: "landing.nav.annam", href: "#annam" },
  { labelKey: "landing.nav.betreuer", href: "#betreuer" },
  { labelKey: "landing.nav.ayuErleben", href: "/ayu-erleben" },
  { labelKey: "landing.nav.bookStore", href: "/buch" },
  { labelKey: "landing.nav.faq", href: "#faq" },
] as const;

export const STATS = [
  { value: "180.000+", labelKey: "landing.stats.menschen" },
  { value: "5.000", labelKey: "landing.stats.jahre" },
  { value: "12", labelKey: "landing.stats.phaenotypen" },
  { value: "100%", labelKey: "landing.stats.personalisiert" },
] as const;

export const STEPS = [
  {
    number: "01",
    titleKey: "landing.wasIstAyu.step1Title",
    descriptionKey: "landing.wasIstAyu.step1Desc",
  },
  {
    number: "02",
    titleKey: "landing.wasIstAyu.step2Title",
    descriptionKey: "landing.wasIstAyu.step2Desc",
  },
  {
    number: "03",
    titleKey: "landing.wasIstAyu.step3Title",
    descriptionKey: "landing.wasIstAyu.step3Desc",
  },
] as const;

export const PILLARS = [
  {
    titleKey: "landing.ayurveda.pillar1Title",
    descriptionKey: "landing.ayurveda.pillar1Desc",
    icon: "leaf",
  },
  {
    titleKey: "landing.ayurveda.pillar2Title",
    descriptionKey: "landing.ayurveda.pillar2Desc",
    icon: "activity",
  },
  {
    titleKey: "landing.ayurveda.pillar3Title",
    descriptionKey: "landing.ayurveda.pillar3Desc",
    icon: "brain",
  },
  {
    titleKey: "landing.ayurveda.pillar4Title",
    descriptionKey: "landing.ayurveda.pillar4Desc",
    icon: "clock",
  },
  {
    titleKey: "landing.ayurveda.pillar5Title",
    descriptionKey: "landing.ayurveda.pillar5Desc",
    icon: "shield",
  },
] as const;

export const FAQ_ITEMS = [
  { questionKey: "landing.faq.q1", answerKey: "landing.faq.a1" },
  { questionKey: "landing.faq.q2", answerKey: "landing.faq.a2" },
  { questionKey: "landing.faq.q3", answerKey: "landing.faq.a3" },
  { questionKey: "landing.faq.q4", answerKey: "landing.faq.a4" },
  { questionKey: "landing.faq.q5", answerKey: "landing.faq.a5" },
  { questionKey: "landing.faq.q6", answerKey: "landing.faq.a6" },
  { questionKey: "landing.faq.q7", answerKey: "landing.faq.a7" },
  { questionKey: "landing.faq.q8", answerKey: "landing.faq.a8" },
] as const;

export const TESTIMONIALS = [
  { textKey: "landing.testimonials.t1", name: "Amelia R." },
  { textKey: "landing.testimonials.t2", name: "Daniel K." },
  { textKey: "landing.testimonials.t3", name: "Sophie L." },
  { textKey: "landing.testimonials.t4", name: "Michael R." },
  { textKey: "landing.testimonials.t5", name: "Clara S." },
  { textKey: "landing.testimonials.t6", name: "Isabelle P." },
] as const;

export const TARGET_GROUPS = [
  {
    titleKey: "landing.targetGroup.group1Title",
    descriptionKey: "landing.targetGroup.group1Desc",
    icon: "heart",
  },
  {
    titleKey: "landing.targetGroup.group2Title",
    descriptionKey: "landing.targetGroup.group2Desc",
    icon: "briefcase",
  },
  {
    titleKey: "landing.targetGroup.group3Title",
    descriptionKey: "landing.targetGroup.group3Desc",
    icon: "rocket",
  },
] as const;
